<template>
    <AIconButton
        v-if="componentParams.is_active"
        icon="close-otg-black"
        class="o-integration-close-button"
        @onClick="handleClick()"
    />
</template>

<script>
import { mapGetters } from "vuex";
import AIconButton from '../../atoms/a-icon-button';
import {routerPushHandler} from "@/utils/helpers/common";
import {WEB_INTEGRATION} from "@/utils/constants/route-constants";
import {OBJECT_INFO_CLOSE_CLICK} from "@/utils/constants/bus-events-constants";

export default {
    name: 'OIntegrationCloseButton',
    components: {
        AIconButton
    },
    props: {
        view: {
            type: String,
            default: ''
        },
        isEmitClose: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        commonConfigStyles() {
            return this.getMapConfigProp('components.OIntegrationCloseButton.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.OIntegrationCloseButton.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OIntegrationCloseButton.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.OIntegrationCloseButton.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        isStore() {
            return this.$route.name.includes(WEB_INTEGRATION.STORE.ROOT.NAME)
        },
    },
    methods: {
        handleClick() {
            const name = this.isStore ?
                WEB_INTEGRATION.STORE.INFO.NAME :
                WEB_INTEGRATION.CATALOGUE.LIST.NAME;
            this.isEmitClose && this.$bus.$emit(OBJECT_INFO_CLOSE_CLICK)
            this.$router.push({ name, query: this.$route.query }, routerPushHandler);
        }
    }
}
</script>

<style lang="scss" src="./o-integration-close-button.scss" />
